<div class="layout-col full">
  <mat-tab-group class="flex" animationDuration="0" elderTabGroupRouting="terminalTab">
    @for (type of types; track type) {
      <mat-tab>
        <span *matTabLabel>
          {{ 'shopfloor.controlcenters.type.' + type | translate }}
        </span>
        <app-control-center-browser class="flex" [facility]="facility$ | async" [type]="type">
        </app-control-center-browser>
      </mat-tab>
    }
  </mat-tab-group>
</div>
